import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleHeaderContent, prefillData } from "./editorSlice";
import {
  downloadBlob,
  generateUniqueFilename,
  getCreatePaperBody,
  getHeaderData,
  handleFinalQuestionPayload,
  mapQuestionResponse,
} from "../components/others";

import {
  apiKeyHeader,
  apiKeyHeaderMultiPartFormData2,
} from "../../../../configs/ApiKeys";
import { setDemoUserFormData, setField } from "./slice";
import ToastComponent from "../../../../components/Other/Toast";
import { JoyTour } from "../../../../components/TourGuide";
import axios from "axios";
import {
  boardAndMediumBasedClassesAPI,
  boardAndMediumBasedSubjectsAPI,
  boardsAPI,
  boardsBasedMediumAPI,
} from "../../../../configs/WebService";

const GET_CLASSES_API = "https://web1024.docmaster.in:5007/api/classes";
const GET_SUBJECTS_API = "https://web1024.docmaster.in:5007/api/subjects/link/";
const GET_QSTN_CATEGORIES =
  "https://web1024.docmaster.in:5007/api/subjects/question-types";
const GET_QUESTION_TYPE = "https://web1024.docmaster.in:5007/api/";
const GET_SUBJECT_CHAPTERS =
  "https://web1024.docmaster.in:5007/api/chapters?subject_id=";
const GET_CLASS_SUBJECT_CHAPTERS =
  "https://web1024.docmaster.in:5007/api/chapters?";

const GET_QUESTIONS = "https://web1024.docmaster.in:5007/api/questions/fetch?"; //class_id=10&subject_id=25&chapter_id=3 // &created_by=20 optional
const GET_QUESTIONS_New = "https://web1024.docmaster.in:5007/api/board/fetch?"; //class_id=10&subject_id=25&chapter_id=3 // &created_by=20 optional

const CREATE_PAPER = "https://web1024.docmaster.in:5010/api/questionPaper";

const GET_CREATED_PAPERS =
  "https://web1024.docmaster.in:5010/api/questionPaper?";

const GET_PAPER_META_DATA = `https://web1024.docmaster.in:5010/api/questionPaper/paper_id/`;
// const GET_PAPER_META_DATA = `http://localhost:5010/api/questionPaper/paper_id/`;

const CREATE_NEW_QUESTION = `https://web1024.docmaster.in:5010/api/questions/create-simple-question`;

const GENERATE_PDF = `https://web1024.docmaster.in:5010/general/html-to-pdf`;

async function GETAPIREQUEST(url, type, rejectWithValue) {
  try {
    const response = await axios.get(url, {
      headers: apiKeyHeader()
    });

    return response.data;
  } catch (err) {
    if (err.response) {
      const errorData = err.response.data || {};
      return rejectWithValue(errorData.message || "Failed to fetch " + type);
    }
    return rejectWithValue("Network error while fetching " + type);
  }
}

async function POSTAPIREQUEST(url, type, rejectWithValue, body) {
  try {
    const response = await axios.post(url, body, {
      headers: apiKeyHeader()
    });

    return { data: response.data, body };
  } catch (err) {
    if (err.response) {
      const errorData = err.response.data || {};
      return rejectWithValue(errorData.message || "Failed to save " + type);
    }
    return rejectWithValue("Network error while saving " + type);
  }
}

export const GetClasesThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetClasesThunk",
  async (_, { rejectWithValue, dispatch, getState }) => {
    const apiResponse = await GETAPIREQUEST(
      GET_CLASSES_API,
      "Classes",
      rejectWithValue,
    );

    const state = getState();
    const user = state.authSlice.user;

    if (user?.admin_id === 104) {
      dispatch(
        setDemoUserFormData({
          type: "Question paper",
          maxMarks: "10",
          duration: 100,
          examName: "Formative Assessment",
          termsText: `1. Students must carry their school ID and be present at the scheduled time.
2. Use of mobile phones, smart devices, or unauthorized materials is strictly prohibited.
3. Any form of cheating or malpractice will result in disqualification.
4. Answer sheets must be submitted before leaving the exam hall.
5. The school reserves the right to modify rules or schedules if necessary.`,
        }),
      );

      ToastComponent(
        user,
        "You are 2 steps away from creating the paper. Please select a class to continue.",
        1,
      );
      // JoyTour(
      //   "create-paper-class",
      //   "You are 2 steps away from creating the paper. Please select a class to continue."
      // );
    }

    return apiResponse;
  },
);

export const GetSubjectsThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetSubjectsThunk",
  async ({ classId }, { rejectWithValue }) => {
    const URL = GET_SUBJECTS_API + classId;
    return GETAPIREQUEST(URL, "Subjects", rejectWithValue);
  },
);

export const GetQuestionCategoriesThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetQuestionCategoriesThunk",
  async ({ updateHeader, formData }, { rejectWithValue, dispatch }) => {
    if (updateHeader) {
      const { qstnData, categoryData } = getHeaderData(formData);
      dispatch(
        handleHeaderContent({ category: categoryData, question: qstnData }),
      );
    }

    // Extract classId and subjectId from formData
    const classId = formData?.class || formData?.classId;
    const subjectId = formData?.subject || formData?.subjectId;

    const url = `${GET_QUESTION_TYPE}classes/by-class/${classId}/subject/${subjectId}`;
    return GETAPIREQUEST(url, "Question Categories", rejectWithValue);
  },
);

export const GetSubjectChaptersThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetSubjectChapters",
  async ({ subjectId }, { rejectWithValue }) => {
    const URL = GET_SUBJECT_CHAPTERS + subjectId;
    return GETAPIREQUEST(URL, "Chapters", rejectWithValue);
  },
);

export const GetClassSubjectChaptersThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetClassSubjectChaptersThunk",
  async ({ subjectId, classId }, { rejectWithValue }) => {
    const URL =
      GET_CLASS_SUBJECT_CHAPTERS +
      `subject_id=${subjectId}&class_id=${classId}`;
    return GETAPIREQUEST(URL, "Chapters", rejectWithValue);
  },
);

export const GetQuestionsThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetQuestionsThunk",
  async ({ subjectId, classId, chapterId }, { rejectWithValue }) => {
    const URL =
      GET_QUESTIONS +
      `class_id=${classId}&subject_id=${subjectId}&chapter_id=${chapterId}`;
    return GETAPIREQUEST(URL, "Chapters", rejectWithValue);
  },
);

export const GetQuestionsByCategoryThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetQuestionsByCategoryThunk",
  async (
    { subjectId, classId, chapterId, categoryId, board_id, medium_id },
    { rejectWithValue },
  ) => {
    const URL =
      GET_QUESTIONS_New +
      `class_id=${classId}&subject_id=${subjectId}&chapter_id=${chapterId}&question_typeid=${categoryId}&board_id=${board_id}&medium_id=${medium_id}`;
    return GETAPIREQUEST(URL, "Chapters", rejectWithValue);
  },
);

export const SaveQuestionPaperThunk = createAsyncThunk(
  "CreateQstnPaperSlice/SaveQuestionPaperThunk",
  async (_, { rejectWithValue, getState }) => {
    const state = getState();
    const user = state.authSlice.user;
    const { formData, subjects, classes } = state.createQstnPaper;
    const { categories, questions } = state.createPaperEditor;

    const body = getCreatePaperBody(
      formData,
      questions,
      categories,
      user.id,
      subjects,
      classes,
    );
    console.log("body", body);

    return POSTAPIREQUEST(CREATE_PAPER, "Create Paper", rejectWithValue, body);
  },
);

export const GetCreatedPapersThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetCreatedPapersThunk",
  async ({ type }, { rejectWithValue, getState }) => {
    const state = getState();
    const user = state.authSlice.user;
    const URL = GET_CREATED_PAPERS + `type=${type}&userId=${user.id}`;

    return GETAPIREQUEST(URL, "Created Papers", rejectWithValue);
  },
);

//old workng
//export const GetPaperMetaDataThunk = createAsyncThunk(
//   "CreateQstnPaperSlice/GetPaperMetaDataThunk",
//   async ({ paperId, type }, { rejectWithValue, dispatch }) => {
//     const URL = GET_PAPER_META_DATA + paperId;

//     const response = await GETAPIREQUEST(
//       URL,
//       "Paper Meta Data",
//       rejectWithValue,
//     );

//     const questions =
//       response.meta_data?.questions?.map((q) => q?.details || {}) || [];
//     const categories = response?.meta_data?.categories || [];
//     const formData = JSON.parse(response.form_data);

//     dispatch(GetClasesThunk());
//     dispatch(GetSubjectsThunk({ classId: formData.class }));

//     if (type === 2) {
//       dispatch(
//         GetClassSubjectChaptersThunk({
//           subjectId: formData.subject,
//           classId: formData.class,
//         }),
//       );
//     }
//     dispatch(prefillData({ questions, categories }));

//     return response;
//   },
// );

export const CreateSimpleQuestionThunk = createAsyncThunk(
  "questions/createSimpleQuestion",
  async (formData, thunkAPI) => {
    const { rejectWithValue, dispatch } = thunkAPI;

    try {
        const res = await axios.post(`${CREATE_NEW_QUESTION}`, formData, {
          headers: apiKeyHeaderMultiPartFormData2(),
        });
        const data = res.data;
        const mapped = mapQuestionResponse(data.data);
        handleFinalQuestionPayload(mapped, dispatch);
        return mapped;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);
export const downloadPDFThunk = createAsyncThunk(
  "download/pdf",
  async (html, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;

    try {
      const res = await axios.post(
        `${GENERATE_PDF}`,
        { html },
        { responseType: "blob", headers: apiKeyHeader() },
      );

      const filename = generateUniqueFilename("question-paper", "pdf");
      downloadBlob(res.data, filename);

      return { success: true, filename };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

// export const GetSubjectBoardsThunk = createAsyncThunk(
//   "CreateQstnPaperSlice/GetSubjectChapters",
//   async ({ subjectId }, { rejectWithValue }) => {
//     const URL = GET_SUBJECT_CHAPTERS + subjectId;
//     return GETAPIREQUEST(URL, "Chapters", rejectWithValue);
//   },
// );
export const GetBoardsThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetBoardsThunk",
  async (_, { rejectWithValue }) => {
    const URL = boardsAPI;
    return GETAPIREQUEST(URL, "Board", rejectWithValue);
  },
);
export const GetMediumThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetMediumThunk",
  async ({ board_id }, { rejectWithValue }) => {
    const URL = boardsBasedMediumAPI + board_id;
    return GETAPIREQUEST(URL, "Medium", rejectWithValue);
  },
);
export const GetClasssesNewThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetClasssesNewThunk",
  async ({ board_id, medium_id }, { rejectWithValue }) => {
    const URL =
      boardAndMediumBasedClassesAPI +
      `?board_id=${board_id}&medium_id=${medium_id}`;
    return GETAPIREQUEST(URL, "Classes", rejectWithValue);
  },
);
export const GetSubjectsNewThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetSubjectsNewThunk",
  async ({ class_id }, { rejectWithValue }) => {
    const URL = boardAndMediumBasedSubjectsAPI + class_id;
    return GETAPIREQUEST(URL, "Subjects", rejectWithValue);
  },
);

export const GetPaperMetaDataThunk = createAsyncThunk(
  "CreateQstnPaperSlice/GetPaperMetaDataThunk",
  async ({ paperId, type }, { rejectWithValue, dispatch }) => {
    const URL = GET_PAPER_META_DATA + paperId;

    const response = await GETAPIREQUEST(
      URL,
      "Paper Meta Data",
      rejectWithValue,
    );

    const questions =
      response.meta_data?.questions?.map((q) => q?.details || {}) || [];
    const categories = response?.meta_data?.categories || [];
    const formData = JSON.parse(response.form_data);
    console.log("formData", JSON.stringify(formData));
    dispatch(GetMediumThunk({ board_id: formData?.board_id }));
    dispatch(
      GetClasssesNewThunk({
        board_id: formData.board_id,
        medium_id: formData?.medium_id,
      }),
    );
    // const parseDurationToHoursMinutes = (duration) => {
    //   let hours = 0;
    //   let minutes = 0;

    //   if (!duration) {
    //     return { hours, minutes };
    //   }

    //   // If duration is a number or numeric string → treat as minutes
    //   if (!isNaN(duration)) {
    //     return { hours: 0, minutes: Number(duration) };
    //   }

    //   // Normalize string
    //   const text = duration.toLowerCase();

    //   // Extract hours
    //   const hourMatch = text.match(/(\d+)\s*hour/);
    //   if (hourMatch) {
    //     hours = Number(hourMatch[1]);
    //   }

    //   // Extract minutes
    //   const minuteMatch = text.match(/(\d+)\s*minute/);
    //   if (minuteMatch) {
    //     minutes = Number(minuteMatch[1]);
    //   }

    //   return { hours, minutes };
    // };

    const parseDurationToHoursMinutes = (duration) => {
      let hours = 0;
      let minutes = 0;

      if (!duration) {
        return { hours, minutes };
      }

      // If duration is a number or numeric string → treat as minutes
      if (!isNaN(duration)) {
        const totalMinutes = Number(duration);
        hours = Math.floor(totalMinutes / 60);
        minutes = totalMinutes % 60;
        return { hours, minutes };
      }

      const text = duration.toLowerCase();

      // Extract hours
      const hourMatch = text.match(/(\d+)\s*hour/);
      if (hourMatch) {
        hours = Number(hourMatch[1]);
      }

      // Extract minutes
      const minuteMatch = text.match(/(\d+)\s*minute/);
      if (minuteMatch) {
        minutes = Number(minuteMatch[1]);
      }

      // Normalize minutes → hours
      if (minutes >= 60) {
        hours += Math.floor(minutes / 60);
        minutes = minutes % 60;
      }

      return { hours, minutes };
    };
    const { hours, minutes } = parseDurationToHoursMinutes(formData.duration);

    dispatch(setField({ key: "hours", value: hours }));
    dispatch(setField({ key: "minutes", value: minutes }));

    dispatch(GetSubjectsNewThunk({ class_id: formData.class }));

    if (type === 2) {
      dispatch(
        GetClassSubjectChaptersThunk({
          subjectId: formData.subject,
          classId: formData.class,
        }),
      );
    }
    dispatch(prefillData({ questions, categories }));

    return response;
  },
);
